import { Img } from "components";
import TextArea from "../components/TextArea";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useSpotlight } from 'react-spotlight-tour';
import { useSpotlight } from "../components/SpotLight";
import Stepper from "../components/Stepper";
import AvatarVideo from "../components/AvatarVideo";
import Wrapper from "../components/Wrapper";

const videoLinks = [
    {url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/text-gen.mp4"}
]

const TextGen = () => {
    const [values, setValues] = useState("");

    // const step1Ref = useSpotlight("");
    // const step2Ref = useSpotlight("");
    // const step3Ref = useSpotlight("");
  
    return (
        <Wrapper
            title={"Instant, AI-Written Content"}
            description={"Just type your school’s or faculty’s name—we’ll handle the rest!"}
            videoLinks={videoLinks}
            body={
                 <div className="grid grid-cols-2 gap-4 w-full">
                     <div className="space-y-9">
                         <h2 className="text-smd_blue-normal font-manropeSB text-[4vh]">How we do it?</h2>
                         <p  className={`text-[2.4vh]`}>✏️ <span className="font-manropeSB">Type Once:</span> Enter your school’s or faculty’s name</p>
                         <p className={`text-[2.4vh]`}>🤖 <span className="font-manropeSB">AI Generates:</span> Professional, SEO-friendly content instantly</p>
                         <p className={`text-[2.4vh]`}>🎯 <span className="font-manropeSB">Engaging & Unique:</span>Tailored to your school’s or faculty’s vision</p>
                     </div>
                     <div>
                         <TextArea
                             isData={values}
                             setData={setValues}
                         />
                     </div>
                 </div>
            }
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     <div className="font-manrope py-[5vh] px-[10vh] flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" className="w-[40vh]" /></div>
        //                 <div className="text-center self-end space-y-2 col-span-8">
        //                     <strong><h1 className="font-inter text-smd_blue-normal text-[6vh] font-bold leading-[120%]">Instant, AI-Written Content</h1></strong>
        //                     <p className="text-[2vh] font-medium">Just type your school’s or faculty’s name—we’ll handle the rest!</p>
        //                 </div>
        //                 <div className="col-span-2 flex justify-end">
        //                    {/* <AvatarVideo videoLinks={videoLinks} /> */}
        //                    <Img src={"/images/soomuch-demo/VideoLoader.png"} className="w-[18vh] h-[18vh] object-top object-cover rounded-lg" />
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="grid grid-cols-2 gap-4 w-full">
        //             <div className="space-y-9">
        //                 <h2 className="text-smd_blue-normal font-manropeSB text-[4vh]">How we do it?</h2>
        //                 <p  className={`tracking-widest text-[2.4vh]`}>✏️ <span className="font-manropeSB">Type Once:</span> Enter your school’s or faculty’s name</p>
        //                 <p className={`tracking-widest text-[2.4vh]`}>🤖 <span className="font-manropeSB">AI Generates:</span> Professional, SEO-friendly content instantly</p>
        //                 <p className={`tracking-widest text-[2.4vh]`}>🎯 <span className="font-manropeSB">Engaging & Unique:</span>Tailored to your school’s or faculty’s vision</p>
        //             </div>
        //             <div>
        //                 <TextArea
        //                     isData={values}
        //                     setData={setValues}
        //                 />
        //             </div>
        //         </div>
        //         <Stepper />
        //     </div>
        // </div>
    );
}

export default TextGen;